import dayjs from 'dayjs'
import { useMemo } from 'react'

type BadgeKey = 'live' | 'today' | 'tomorrow' | 'resolved' | 'inDays'

export interface DateBadge {
  key: BadgeKey
  values?: { days: number }
}

export function useDateBadge(eventDate?: string, status?: string): DateBadge | null {
  return useMemo(() => {
    if (!eventDate) return null
    if (status === 'resolved') return { key: 'resolved' }

    const date = dayjs(eventDate)
    const now = dayjs()

    if (date.isBefore(now)) return { key: 'live' }
    if (date.isSame(now, 'day')) return { key: 'today' }
    if (date.isSame(now.add(1, 'day'), 'day')) return { key: 'tomorrow' }

    const days = date.startOf('day').diff(now.startOf('day'), 'day')
    return { key: 'inDays', values: { days } }
  }, [eventDate, status])
}
